import _ from 'lodash';
import BillyApi from '@/api/BillyApi';
import Segment from '@/Segment';
import DDLogs from '@/DDLogs';

export default function createOfferingPaymentModule({ offeringIds, flow }) {
  const state = {
    oneOffOfferings: [],
    selectedOffering: null,
    installmentsCount: 1,
    initialized: false,
  };

  const getters = {
    selectedOffering: state => state.selectedOffering,
    installmentsCount: state => state.installmentsCount,
    price: state => state.selectedOffering?.price?.amount ?? null,
    offerings: state => (offeringIds
      ? offeringIds.map(id => _.find(state.oneOffOfferings, offering => offering.id === id)).filter(Boolean)
      : state.oneOffOfferings),
  };

  const actions = {
    async fetchOfferings({ state, commit }) {
      if (!state.initialized) {
        const { oneOffOfferings } = await BillyApi.getOfferingsNoAuth();
        commit('setOneOffOfferings', oneOffOfferings);
        commit('setInitialized', true);
      }
    },
    async init({ commit, dispatch }, { offeringId }) {
      await dispatch('fetchOfferings');
      commit('selectOffering', { offeringId });
    },
    async purchaseLead({ state }, {
      paymeToken, phoneNumber, firstName, lastName, email, enableMarketingEmails, otpCode,
    }) {
      try {
        const { id } = state.selectedOffering;
        const result = await BillyApi.leadPurchase({
          phoneNumber,
          firstName,
          lastName,
          email,
          enableMarketingEmails,
          token: paymeToken && paymeToken.token,
          otpCode,
          oneOffOfferings: [{ offeringId: id, numberOfInstallments: state.installmentsCount }],
        });
        Segment.trackUserGot('LeadPurchaseSucceeded', { offeringId: id, flow });
        return result;
      } catch (error) {
        const reason = error && error.response && error.response.data && error.response.data.result;
        DDLogs.errorBusinessEvent('Lead purchase failed', { message: error && error.message, reason, flow });
        throw new Error(reason === 'invalid_otp' ? 'invalid_otp' : 'Lead purchase failed');
      }
    },
  };

  const mutations = {
    setOneOffOfferings(state, oneOffOfferings) {
      state.oneOffOfferings = oneOffOfferings;
    },
    selectOffering(state, { offeringId }) {
      state.selectedOffering = _.find(state.oneOffOfferings, offering => offering.id === offeringId);
      state.installmentsCount = 1;
    },
    setInitialized(state, initialized) {
      state.initialized = initialized;
    },
    setInstallmentsCount(state, installmentsCount) {
      state.installmentsCount = installmentsCount;
    },
  };

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
}
